<template>
<div class="c-contact">
    <div class="c-contact__title">
        <picture>
            <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/contact/balloon-sp.png">
            <img class="balloon" src="/lp/assets/img/lp/contact/balloon-pc.png" alt="子どもの入学時期に間に合うようにしたい。どうすれば？？ いまの物件を売る手配もしてくれるの？ 県外から引っ越す場合でも手間はかからない？ ローンの組み方が良くわからないんだけど。 いつ家を買うかわからないけど、新しい情報が欲しい！" width="1342" height="473">
        </picture>
        <picture>
            <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/contact/title-sp.png">
            <img id="c-contact__title" class="title" src="/lp/assets/img/lp/contact/title-pc.png" alt="住宅購入のお悩み事はありませんか？担当者がしっかりご相談に乗ります" width="705" height="249">
        </picture>
    </div>
    <div class="c-contact__form">
        <div id="c-form" class="c-form">
            <div class="c-form__tel">
                <h2>
                    <picture>
                        <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/contact/title-tel-sp.png">
                        <img src="/lp/assets/img/lp/contact/title-tel-pc.png" alt="電話の場合" width="186" height="40">
                    </picture>
                </h2>
                <dl>
                    <dt>フリーダイヤル</dt>
                    <dd>
                        <a href="tel:0120592821">0120-592-821</a>
                        <p>( 営業時間 10:00 〜 18:30 火・水曜定休 )</p>
                    </dd>
                </dl>
            </div>
            <div id="c-form__input" class="c-form__input">
                <h2>
                    <picture>
                        <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/contact/title-mail-sp.png">
                        <img src="/lp/assets/img/lp/contact/title-mail-pc.png" alt="メールの場合" width="212" height="40">
                    </picture>
                </h2>

                <!-- 入力 -->
                <Transition name="fade">
                <div class="c-entry" v-show="isState === 'entry'">
                    <div class="c-entry__head">
                        <p>フォームよりお気軽に<br>ご相談ください。</p>
                        <p><span>*</span>は必須事項</p>
                    </div>
                    <div class="c-entry__body">
                        <form method="POST" enctype="multipart/form-data">
                        <ul class="c-entry__body__form">
                            <li>
                                <div class="multi-check">
                                    <p class="label">ご相談内容<span>*</span><br>(複数可)</p>
                                    <ul class="multi-check__list">
                                        <li>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    v-model="yourType"
                                                    id="yourType1"
                                                    name="yourType"
                                                    :value="'資料請求したい'"
                                                >資料請求したい
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    v-model="yourType"
                                                    id="yourType2"
                                                    name="yourType"
                                                    :value="'内見予約したい'"
                                                >内見予約したい
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    v-model="yourType"
                                                    id="yourType3"
                                                    name="yourType"
                                                    value="住む場所について相談したい"
                                                >住む場所について相談したい
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    v-model="yourType"
                                                    id="yourType4"
                                                    name="yourType"
                                                    value="ローンについて相談したい"
                                                >ローンについて相談したい
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    v-model="yourType"
                                                    id="yourType5"
                                                    name="yourType"
                                                    value="不動産の売却について相談したい"
                                                >不動産の売却について相談したい
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    v-model="yourType"
                                                    id="yourType6"
                                                    name="yourType"
                                                    value="その他（詳しいご相談内容欄にご記入ください）"
                                                >その他<br class="u-none-b--sp">（詳しいご相談内容欄にご記入ください）
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                <span v-if="errors.yourType" class="error error--type" id="error-yourType" aria-live="assertive">
                                    {{ errors.yourType }}
                                </span>
                            </li>
                            <li>
                                <label>
                                    <p class="label">ご希望のエリア</p>
                                    <input
                                    placeholder="例）品川まで通勤1時間のエリア"
                                    :class="{'entered': yourArea}"
                                    v-model="yourArea"
                                    size="100"
                                    aria-required="false"
                                    aria-invalid="false"
                                    type="text"
                                    id="yourArea"
                                    name="yourArea">
                                </label>
                                <span v-if="errors.yourArea" class="error" aria-live="assertive">
                                    {{ errors.yourArea }}
                                </span>
                                <p class="note">ご希望がありましたら、ご記入ください</p>
                            </li>
                            <li>
                                <label>
                                    <p class="label">お名前<span>*</span></p>
                                    <input
                                    placeholder="例）新昭和花子"
                                    :class="{'entered': yourName}"
                                    v-model="yourName"
                                    size="40"
                                    aria-required="true"
                                    aria-invalid="false"
                                    type="text"
                                    id="yourName"
                                    name="yourName">
                                </label>
                                <span v-if="errors.yourName" class="error" aria-live="assertive">
                                    {{ errors.yourName }}
                                </span>
                            </li>
                            <li>
                                <label>
                                    <p class="label">メールアドレス<span>*</span></p>
                                    <input
                                    placeholder="例）example@withearthgarden.jp"
                                    :class="{'entered': yourEmail}"
                                    v-model="yourEmail"
                                    size="40"
                                    aria-required="true"
                                    aria-invalid="false"
                                    type="text"
                                    id="yourEmail"
                                    name="yourEmail">
                                </label>
                                <span v-if="errors.yourEmail" class="error" aria-live="assertive">
                                    {{ errors.yourEmail }}
                                </span>
                            </li>
                            <li>
                                <label>
                                    <p class="label">電話番号</p>
                                    <input
                                    placeholder="例）0120592821"
                                    :class="{'entered': yourTel}"
                                    v-model="yourTel"
                                    size="40"
                                    aria-required="true"
                                    aria-invalid="false"
                                    type="text"
                                    id="yourTel"
                                    name="yourTel">
                                </label>
                                <span v-if="errors.yourTel" class="error" aria-live="assertive">
                                    {{ errors.yourTel }}
                                </span>
                            </li>
                            <li>
                                <label>
                                    <p class="label">住所</p>
                                    <input
                                    placeholder="例）千葉県市川市市川1-26-1"
                                    :class="{'entered': yourAddress}"
                                    v-model="yourAddress"
                                    size="40"
                                    aria-required="true"
                                    aria-invalid="false"
                                    type="text"
                                    id="yourAddress"
                                    name="yourAddress">
                                </label>
                                <span v-if="errors.yourAddress" class="error" aria-live="assertive">
                                    {{ errors.yourAddress }}
                                </span>
                            </li>
                            <li>
                                <label>
                                    <p class="label">詳しい<br class="u-none-b--pc">ご相談内容<span>*</span></p>
                                    <textarea 
                                        :class="{'entered': yourMessage}"
                                        v-model="yourMessage"
                                        cols="40"
                                        rows="10"
                                        aria-invalid="false"
                                        id="yourMessage"
                                        name="yourMessage"
                                    ></textarea>
                                </label>
                                <span v-if="errors.yourMessage" class="error" aria-live="assertive">
                                    {{ errors.yourMessage }}
                                </span>
                            </li>
                            <li>
                                <div class="c-privacy">
                                    <div class="c-privacy__wrap">
                                        <div class="content">
                                            <p>当社が取得収集させていただきました、お客様の個人情報（氏名、住所、生年月日、勤務先、年収、電話番号、メールアドレス等）は、以下の目的に利用いたします。</p>
                                            <p>当社および株式会社新昭和のグループ会社が行う次の事業に関し、郵便による資料送付、電子メールによる情報提供、電話等による商品案内等の営業活動を行なうため。</p>
                                            <p>
                                                不動産の売買・賃貸、それらの代理・仲介・管理事業<br>
                                                建築工事・リフォーム工事・その総合工事の設計・施工・監理・請負事業<br>
                                                家具インテリア商品の販売事業<br>
                                                火災保険・損害保険媒介代理事業<br>
                                                発電事業およびその管理・運営ならびに電気の売買等に関する事業<br>
                                                情報処理、情報提供サービス事業および電気通信事業法に定める電気通信事業<br>
                                            </p>
                                            <p>
                                                上記の事業に付随する住まいに関する商品の小売事業　等<br>
                                                顧客動向分析もしくは商品開発等の調査分析のため。
                                            </p>
                                            <p>
                                                ※当社、個人情報のお取扱いについてのページはこちらから<br>
                                                <a href="https://www.shinshowa.co.jp/privacy_policy/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">https://www.shinshowa.co.jp/privacy_policy/</a>
                                                <br>
                                                ※電子メールによるお問い合わせ専用フォーム(SSL暗号化通信対応)はこちらから<br>
                                                <a href="https://www.withearth.jp/inquiry/contact/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">https://www.withearth.jp/inquiry/contact/</a>
                                                <br><br>
                                                以上
                                            </p>
                                        </div>
                                    </div>
                                    <div class="c-privacy__agree">
                                        <label>
                                            <input
                                                type="checkbox"
                                                v-model="yourAgree"
                                                id="yourAgree"
                                                name="yourAgree"
                                                value="agree"
                                            >個人情報の利用目的に同意する
                                        </label>
                                    </div>
                                    <span v-if="errors.yourAgree" class="error error--agree" id="error-yourAgree" aria-live="assertive">
                                        {{ errors.yourAgree }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div class="btns">
                            <a class="c-btn c-btn--confirm" href="#" @click.prevent="onConfirm">内容の確認</a>
                        </div>
                        </form>
                    </div>
                </div>
                </Transition>

                <!-- 確認 -->
                <Transition name="fade">
                <div id="c-confirm" class="c-confirm" v-show="isState === 'confirm'">
                    <div class="c-confirm__head">
                        <p>内容を確認の上<br>送信ボタンを押してください</p>
                    </div>
                    <div class="c-confirm__body">
                        <ul>
                            <li>
                                <p>ご相談内容</p>
                                <p>
                                    <span v-for="type in confirmData.yourType">{{ type }}</span>
                                </p>
                            </li>
                            <li>
                                <p>ご希望のエリア</p>
                                <p>{{ confirmData.yourArea }}</p>
                            </li>
                            <li>
                                <p>お名前</p>
                                <p>{{ confirmData.yourName }}</p>
                            </li>
                            <li>
                                <p>メールアドレス</p>
                                <p>{{ confirmData.yourEmail }}</p>
                            </li>
                            <li>
                                <p>電話番号</p>
                                <p>{{ confirmData.yourTel }}</p>
                            </li>
                            <li>
                                <p>住所</p>
                                <p>{{ confirmData.yourAddress }}</p>
                            </li>
                            <li>
                                <p>詳しい<br class="u-none-b--pc">ご相談内容</p>
                                <pre>{{ confirmData.yourMessage }}</pre>
                            </li>
                        </ul>
                        <div class="btns">
                            <a class="c-btn c-btn--back" href="#" @click.prevent="onBack">修正する</a>
                            <a class="c-btn c-btn--send" href="#" @click.prevent="onSend" data-gtm-label="contact-submit">送信する</a>
                        </div>
                    </div>
                </div>
                </Transition>

                <!-- 完了 -->
                <Transition name="fade">
                <div id="c-complete" class="c-complete" v-show="isState === 'complete'">
                    <p>お問い合わせありがとうございました。担当者よりご連絡いたします。</p>
                </div>
                </Transition>

                <div class="c-form__google">
                    <p>This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script setup>

// if (process.client) {}

import { gsap, Quart } from 'gsap/all';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

import { ref, nextTick, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useForm, useField } from 'vee-validate';
import * as yup from 'yup';

const store = useStore();
const isState = ref('entry');
const confirmData = ref({
        formTitle: '',
        yourType: [],
        yourArea: '',
        yourName: '',
        yourEmail: '',
        yourTel: '',
        yourAddress: '',
        yourMessage: '',
        yourAgree: '',
      });
const formData = ref(null);
const recaptchaToken = ref(null);

// 入力内容チェック
const schema = yup.object({
    yourType: yup.array().min(1, '選択してください').required('選択してください'),
    yourArea: yup.string().max(200, "100文字以下で入力してください"),
    yourName: yup.string().required("この項目は必須です").max(100, "100文字以下で入力してください"),
    yourEmail: 
        yup.string()
        .email("メールアドレスの形式で入力してください")
        .required("この項目は必須です")
        .max(300, "300文字以下で入力してください"),
    yourTel: yup.string().max(100, "100文字以下で入力してください"),
    yourAddress: yup.string().max(100, "300文字以下で入力してください"),
    yourMessage: yup.string().required("この項目は必須です").max(1000, "1000文字以下で入力してください"),
    yourAgree: yup.boolean().default(false).isTrue('同意が必要です'),
});

const { handleSubmit, defineField, errors } = useForm({
    validationSchema: schema,
    initialValues: {
        formTitle: 'ウィザースガーデン',
        yourType: [],
    },
});

// useFieldで複数チェックボックスを管理
const [ yourType, yourTypeProps ] = defineField('yourType');
const { value: yourArea } = useField('yourArea');
const { value: yourName } = useField('yourName');
const { value: yourEmail } = useField('yourEmail');
const { value: yourTel } = useField('yourTel');
const { value: yourAddress } = useField('yourAddress');
const { value: yourMessage } = useField('yourMessage');
const { value: yourAgree } = useField('yourAgree');

// 送信内容にエラーがあった場合に実行
const onInvalidSubmit = ({ values, errors, results }) => {
    // scrollTo(0);
    // console.log(values, errors, results);

    nextTick(() => {
        // anchor('c-confirm');
        anchor('c-form');
    });
}

// 入力内容を送信データに格納
const sendData = (values) => {
    formData.value = new FormData();
    Object.entries(values).forEach(([key, val]) => {
        confirmData.value[key] = val;
        if (key === 'yourType') {
            formData.value.append(key, val.join(',') ?? '');
        } else {
            formData.value.append(key, val ?? '');
        }
    });
};

// 送信データを削除
const deleteData = () => {
    const keys = [];
    for (const key of formData.value.keys()) {
        keys.push(key);
    }
    for (const idx in keys) {
        formData.value.delete(keys[idx]);
    }
}

// 送信内容を確認する
const onConfirm = handleSubmit(async (values) => {
    sendData(values);
    isState.value = 'confirm';
    nextTick(() => {
        // anchor('c-confirm');
        anchor('c-form');
    });
}, onInvalidSubmit);

// 修正する 入力画面へ
const onBack = () => {
    isState.value = 'entry';
    nextTick(() => {
        anchor('c-form');
    });
}

const sendCheck = async () => {
    recaptchaToken.value = '';
    try {
        const token = await grecaptcha.execute('6LdT3hAqAAAAANa_Y_C_3J6H94oUteWhjCv6If1i', {
        action: 'submit'
        });
        recaptchaToken.value = token;
        return send();
    } catch (error) {
        console.log(error);
        return false;
    }
}

const send = async () => {
    // contact form 7
    formData.value.append('_wpcf7_recaptcha_response', recaptchaToken.value);
    formData.value.append('_wpcf7', '5');
    formData.value.append('_wpcf7_version', '5.9.7');
    formData.value.append('_wpcf7_locale', 'ja');
    formData.value.append('_wpcf7_unit_tag', `wpcf7-f5-o1`);

    // for (let value of formData.value.entries()) {
    //      console.log(value);
    // }

    try {

        let formEndPoint = 'https://shinshowa.homun.net/lp/manage/wp-json/contact-form-7/v1/contact-forms/5/feedback';
        if (location.hostname === 'withearthgarden.jp') {
            formEndPoint = 'https://withearthgarden.jp/lp/manage/wp-json/contact-form-7/v1/contact-forms/5/feedback';
        }

        // console.log(formEndPoint);
        const response = await fetch(formEndPoint, {
            mode: 'cors',
            method: 'POST',
            body: formData.value,
            // content-typeは指定しない
            // headers: {
            //     'Content-Type': 'multipart/form-data',
            // }
        });

        if (response.ok) {
            const data = await response.json();
            if (data.status === 'spam' || data.status === 'validation_failed') {
              console.log(data);
              return false;
            }
            return true;
        } else {
            console.log(response);
            return false;
            // await navigateTo('/error')
        }
    } catch (error) {

        console.log(error);
        return false;
        //await navigateTo('/error')
    }
}

// 送信する
const isSend = ref(false);
const onSend = async () => {
    if (isSend.value) return;
    isSend.value = true;

    if (await sendCheck()) {
        // router.push('/contact/complete/').then(() => {
        //     hideConfirm();
        // });

        // 完了画面
        isState.value = 'complete';

        nextTick(() => {
            // anchor('c-complete');
            anchor('c-form');
            addKasikaTag();
        });
    } else {
        // error
        isSend.value = false;
        alert('Server Error. ご迷惑をおかけして申し訳ありませんが、しばらく時間をおいてから再度アクセスしてください。');
    }

    // フォーム入力データ削除
    // deleteData();
}

// KASIKA
const addKasikaTag = () => {
    // for (let value of formData.value.entries()) {
    //      console.log(value);
    // }
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.src = `//panda.kasika.io/tracking_conversion/?pid=E6F5A5ABCB6FEEBD12328D83E9FAF8A3&cf90=${encodeURI(formData.value.get('yourType'))}&cf91=${encodeURI(formData.value.get('yourArea'))}&ce=${encodeURI(formData.value.get('yourEmail'))}&cn=${encodeURI(formData.value.get('yourName'))}&cp=${encodeURI(formData.value.get('yourTel'))}&add=${encodeURI(formData.value.get('yourAddress'))}&ref=${encodeURI(formData.value.get('yourMessage'))}&conversion_name=${encodeURI('東京神奈川LP')}&source=${encodeURI('東京神奈川LP')}&enc=UTF-8`;
    document.body.appendChild(scriptTag);
}

// アンカースクロール
const anchor = (id) => {
    gsap.to(window, { duration: 0.8, scrollTo: { y: `#${id}`, autoKill: false }, ease: Quart.easeInOut});
}

</script>